import React, { useState } from "react";
import "./ClientResultsShowcase.css";
import LargeHeaderTitle from "./LargeHeaderTitle";

// Import all client result images
import evalJade from "../images/clientresults/eval_50k_jade.jpeg";
import evalDaniel from "../images/clientresults/eval_50k_daniel.jpg";
import evalBrett from "../images/clientresults/eval_50k_brett.jpg";
import evalAubrey from "../images/clientresults/eval_50k_aubrey.jpg";
import liveAccount1 from "../images/clientresults/live_account_zta1.png";
import liveAccount2 from "../images/clientresults/live_account_zta2.png";
import liveDaniel1 from "../images/clientresults/live_account_daniel_1.png";
import liveDaniel2 from "../images/clientresults/live_account_daniel_2.png";
import payoutAubrey1 from "../images/clientresults/payout_1_aubrey.png";
import payoutAubrey2 from "../images/clientresults/payout_2_aubrey.png";
import payoutJade1 from "../images/clientresults/payout_1_jade.png";

const ClientResultsShowcase = () => {
  const [activeTab, setActiveTab] = useState("evaluations");

  const results = {
    evaluations: [
      { image: evalJade, name: "Jade", amount: "50K" },
      { image: evalDaniel, name: "Daniel", amount: "50K" },
      { image: evalBrett, name: "Brett", amount: "50K" },
      { image: evalAubrey, name: "Aubrey", amount: "50K" },
    ],
    liveAccounts: [
      { image: liveAccount1, name: "ZTA Client", type: "Live Account" },
      { image: liveAccount2, name: "ZTA Client", type: "Live Account" },
      { image: liveDaniel1, name: "Daniel", type: "Live Account" },
      { image: liveDaniel2, name: "Daniel", type: "Live Account" },
    ],
    payouts: [
      { image: payoutAubrey1, name: "Aubrey", type: "Payout" },
      { image: payoutAubrey2, name: "Aubrey", type: "Payout" },
      { image: payoutJade1, name: "Jade", type: "Payout" },
    ],
  };

  return (
    <div className="client-results-container">
      <div className="results-header">
        <LargeHeaderTitle title="Real " highlight="Results" />
        <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
          See how our clients are achieving consistent success with our automated trading systems
        </p>
      </div>

      <div className="results-tabs">
        <button
          className={`tab-button ${activeTab === "evaluations" ? "active" : ""}`}
          onClick={() => setActiveTab("evaluations")}
        >
          Funded Evaluations
        </button>
        <button
          className={`tab-button ${activeTab === "liveAccounts" ? "active" : ""}`}
          onClick={() => setActiveTab("liveAccounts")}
        >
          Live Accounts
        </button>
        <button
          className={`tab-button ${activeTab === "payouts" ? "active" : ""}`}
          onClick={() => setActiveTab("payouts")}
        >
          Payouts
        </button>
      </div>

      <div className="results-grid">
        {results[activeTab].map((result, index) => (
          <div 
            key={index} 
            className="result-card"
            data-type={activeTab === "payouts" ? "payout" : ""}
          >
            <div className="result-image-container">
              <img
                src={result.image}
                alt={`${result.name}'s ${result.type || 'Evaluation'}`}
                className="result-image"
              />
              <div className="result-overlay">
                <span className="result-name">{result.name}</span>
                {result.amount && (
                  <span className="result-amount">${result.amount}</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="results-cta">
        <p className="text-xl text-gray-300 mb-6">
          Ready to start your journey to consistent profits?
        </p>
        <button className="cta-button">
          Book Your Demo
        </button>
      </div>
    </div>
  );
};

export default ClientResultsShowcase; 